/** The booking record's switchable views (`?view=spine|tabs`, plan D1, §1.1): both lay
 *  out the one section registry and share the draft, the ledger and Save. */
import { SPINE_VIEW } from './spineLayout';
import { TABS_VIEW } from './tabsLayout';

export const BOOKING_RECORD_VIEWS = [SPINE_VIEW, TABS_VIEW];
